import { gql } from '@graphql/__generated__';

export const GET_MY_PRODUCT_EXPERIENCES = gql(/* GraphQL */ `
  query GetMyProductExperiences($userId: uuid!) {
    users_by_pk(id: $userId) {
      id
      product_experiences {
        kind
        key
        first_seen_at
        outcome
        outcome_at
        last_step
        step_count
        dismiss_reason
        dismiss_count
        holdout
      }
    }
  }
`);

// Insert-or-update. `user_id` is preset from the session by Hasura. An empty
// `update_columns` keeps the existing row (first seen stays first seen).
export const RECORD_PRODUCT_EXPERIENCES = gql(/* GraphQL */ `
  mutation RecordProductExperiences(
    $objects: [user_product_experiences_insert_input!]!
    $updateColumns: [user_product_experiences_update_column!]!
    $where: user_product_experiences_bool_exp = {}
  ) {
    insert_user_product_experiences(
      objects: $objects
      on_conflict: {
        constraint: user_product_experiences_pkey
        update_columns: $updateColumns
        where: $where
      }
    ) {
      affected_rows
    }
  }
`);

export const RESET_MY_PRODUCT_EXPERIENCES = gql(/* GraphQL */ `
  mutation ResetMyProductExperiences($userId: uuid!) {
    delete_user_product_experiences(where: { user_id: { _eq: $userId } }) {
      affected_rows
    }
  }
`);
